
/**
 * 评述报告获取请求
 */
export interface NoveltyReviewRequest {
    taskId: string;
}

/**
 * 评述项类型
 */
export type NoveltyReviewType = 'Y' | 'X' | 'A';

/**
 * 评述分类
 */
export type NoveltyReviewCategory = 'creativity' | 'novelty';

/**
 * 单个评述项
 */
export interface NoveltyReviewItem {
    /**
     * 评述类型
     */
    type: NoveltyReviewType;
    /**
     * 评述分类
     */
    category: NoveltyReviewCategory;
    /**
     * 评述标题
     */
    title: string;
    /**
     * 评述内容
     */
    content: string;
}

/**
 * 评述报告获取响应
 */
export type NoveltyReviewResponse = NoveltyReviewItem[]

/**
 * 异步评述报告响应
 */
export interface NoveltyReviewAsyncResponse {
    /**
     * 任务状态：SUCCESS, FAILED, RUNNING
     */
    status: 'SUCCESS' | 'FAILED' | 'RUNNING';
    /**
     * 评述报告数据（当 status 为 SUCCESS 时返回）
     */
    result?: NoveltyReviewResponse;
    /**
     * 错误信息（当 status 为 FAILED 时返回）
     */
    error_message?: string;
    /**
     * 任务ID
     */
    task_id: string;
}

/**
 * 评述报告获取 API
 */
export interface NoveltyReviewApi {
    /**
     * 获取评述报告
     * @param params 评述报告获取请求
     * @param signal abort 信号
     * @returns 评述报告获取响应
     */
    getNoveltyReview(params: NoveltyReviewRequest, signal?: AbortSignal): Promise<NoveltyReviewAsyncResponse>;
}

export const NoveltyReviewApi = Symbol.for('NoveltyReviewApi');

